import { trackStructEvent } from "@snowplow/browser-tracker";

import loggy from "@catchoftheday/loggy";

import { Experiment } from "@analytics/generated/graphql";

import { subscribeToPathname } from "../utilities";
import { spExperimentEvents } from "../vendors/snowplow/context-api";

let firedEvents: Record<string, boolean> = {};
export function clearFiredEvents() {
  firedEvents = {};
}

// Reset firedEvents whenever navigating to a new page
subscribeToPathname((_path) => {
  clearFiredEvents();
});

async function triggerABExperimentEvents(pathname: string) {
  const events = await spExperimentEvents(pathname);
  events.forEach((event) => {
    if (!firedEvents[event.value]) {
      firedEvents[event.value] = true;
      trackStructEvent(event);
    }
  });
}

export function listenToABEvents() {
  // AB Experiment Events
  triggerABExperimentEvents(location.pathname);
  subscribeToPathname((pathname) => {
    triggerABExperimentEvents(pathname);
  });
}

export function fireABEvents(experiments: Experiment[]) {
  experiments.forEach((exp) => {
    if (!firedEvents[exp.id || ""] && exp.active && exp.name && exp.id) {
      try {
        trackStructEvent({
          category: "AB Test",
          action: "Variation Chosen",
          label: exp.name,
          property: exp.variation,
          value: parseInt(exp.id),
        });
        firedEvents[exp.id] = true;
      } catch (e) {
        loggy.error(e);
      }
    }
  });
}
